import * as tslib_1 from "tslib";
import "../../CommonImports";
import "../../Core/core.css";
import "./Tabs.css";
import * as React from "react";
import { Tab } from "./Tab";
import { TabProviderContext } from "./TabProviderContext";
import { Tabs } from "./Tabs";
import { ObservableLike } from '../../Core/Observable';
import { SurfaceContext } from '../../Surface';
import { css } from '../../Util';
/**
 * Renders tabs (provided as children or through a tab provider context) as well as addtional
 * content such as in-line filters, view options, etc.
 *
 * Tabs provided directly as children will always be place before contributed tabs.
 */
var TabBar = /** @class */ (function (_super) {
    tslib_1.__extends(TabBar, _super);
    function TabBar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderAdditionalContent = function (renderFilterBar) {
            if (renderFilterBar) {
                return renderFilterBar(true);
            }
            return _this.props.renderAdditionalContent && _this.props.renderAdditionalContent();
        };
        _this.createTab = function (tab) {
            return (React.createElement(Tab, { badgeCount: tab.badgeCount, key: tab.id, id: tab.id, name: tab.name, onBeforeTabChange: tab.onBeforeTabChange, url: tab.url && ObservableLike.getValue(tab.url) }));
        };
        return _this;
    }
    TabBar.prototype.render = function () {
        var _this = this;
        return (React.createElement(SurfaceContext.Consumer, null, function (surfaceContext) { return (React.createElement(TabProviderContext.Consumer, null, function (tabProviderContext) {
            var selectedTabId = _this.props.selectedTabId || tabProviderContext.selectedId;
            return (React.createElement("div", { className: css(_this.props.className, "bolt-tabbar flex-row flex-center flex-noshrink", !_this.props.disableSticky && "sticky", surfaceContext.background === 1 /* neutral */ && "bolt-tabbar-grey", surfaceContext.background === 2 /* callout */ && "bolt-tabbar-on-callout") },
                React.createElement(Tabs, tslib_1.__assign({ selectedTabId: selectedTabId }, _this.props, { className: css(_this.props.tabsClassName, "bolt-tabbar-tabs flex-grow flex-noshrink") }),
                    _this.props.children,
                    tabProviderContext.tabs.map(_this.createTab)),
                _this.renderAdditionalContent(tabProviderContext.renderFilterBar)));
        })); }));
    };
    return TabBar;
}(React.Component));
export { TabBar };
